/* ShredFin global CRO: sticky header state + dynamic free shipping announcement */
(function () {
  if (window.__sfGlobalCro) return;
  window.__sfGlobalCro = true;

  /* ---------- Sticky header ---------- */

  var root = document.documentElement;
  var header = document.querySelector('.section-sf-header');

  var announce = document.querySelector('.announcement-bar-section');

  function setHeaderHeight() {
    if (header) root.style.setProperty('--sf-header-h', header.offsetHeight + 'px');
    if (announce) root.style.setProperty('--sf-announce-h', announce.offsetHeight + 'px');
  }

  /* ---------- One cart-changed signal for every widget ----------
     Any cart mutation (drawer quantity, remove, size change, quick add,
     product form) fires "sf:cart-changed" so bars and pills refresh
     without a page reload. */
  if (!window.__sfFetchWrapped && window.fetch) {
    window.__sfFetchWrapped = true;
    var nativeFetch = window.fetch.bind(window);
    var mutating = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = nativeFetch(input, init);
      if (mutating.test(url)) {
        p.then(function () {
          setTimeout(function () { document.dispatchEvent(new CustomEvent('sf:cart-changed')); }, 50);
        }).catch(function () {});
      }
      return p;
    };
  }

  function onScroll() {
    root.classList.toggle('sf-scrolled', window.scrollY > 8);
  }

  setHeaderHeight();
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', setHeaderHeight);
  if (header && 'ResizeObserver' in window) new ResizeObserver(setHeaderHeight).observe(header);
  if (announce && 'ResizeObserver' in window) new ResizeObserver(setHeaderHeight).observe(announce);

  /* ---------- Subtle scroll reveal ---------- */

  (function reveal() {
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (window.Shopify && window.Shopify.designMode) return;

    var main = document.getElementById('MainContent') || document.querySelector('main');
    if (!main) return;

    /* Never animate sections that hold fixed UI (sticky bars, drawers, dialogs) */
    var skip = '.sf-pdp-sticky, dialog, cart-drawer, .sf-main-product, .sfc-drawer';
    var targets = [];

    Array.prototype.forEach.call(main.querySelectorAll(':scope > .shopify-section'), function (sec) {
      if (sec.matches('[class*="main-product"]') || sec.querySelector('.sf-pdp-sticky')) return;
      var hasFixedUi = !!sec.querySelector(skip);
      var cards = sec.querySelectorAll('.sfc-card, .sfym-card, .sf-product-card, .sfcb-item, .sf-promo__card, .sfcl-card');
      if (cards.length) {
        Array.prototype.forEach.call(cards, function (card, i) {
          card.style.setProperty('--sf-reveal-delay', (i % 4) * 70 + 'ms');
          targets.push(card);
        });
        var head = sec.querySelector('h1, h2');
        if (head) targets.push(head);
      } else if (!hasFixedUi) {
        targets.push(sec);
      }
    });

    var vh = window.innerHeight;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    targets.forEach(function (el) {
      /* Content already on screen is shown instantly (no flash, no layout delay) */
      if (el.getBoundingClientRect().top < vh * 0.92) return;
      el.classList.add('sf-reveal');
      io.observe(el);
    });

    /* Cards added later (load more, recommendations) appear without animation */
    root.classList.add('sf-anim');
  })();

  /* ---------- Free shipping announcement ---------- */

  var bars = Array.prototype.slice.call(document.querySelectorAll('[data-sf-announce-ship]'));
  var pills = Array.prototype.slice.call(document.querySelectorAll('[data-sf-ship-pill]'));
  if (!bars.length && !pills.length) return;

  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2);
    var whole = String(Math.round(cents / 100));
    return (format || '$' + '{' + '{amount}' + '}')
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, whole)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, whole)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/, value.replace(/\B(?=(\d{3})+(?!\d))/, ','));
  }

  function thresholdFor(el) {
    var base = Number(el.dataset.threshold) || 0;
    if (el.dataset.sameCurrency === 'true') return base;
    var rate = Number((window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1);
    return Math.ceil((base * rate) / 100) * 100;
  }

  function render(total) {
    bars.forEach(function (el) {
      var text = el.querySelector('[data-sf-announce-text]');
      if (!text) return;
      var threshold = thresholdFor(el);
      var format = el.dataset.moneyFormat;
      var remaining = Math.max(threshold - total, 0);
      var pct = threshold ? Math.min(100, (total / threshold) * 100) : 0;

      if (total <= 0) {
        text.innerHTML = 'FREE SHIPPING ON ORDERS OVER ' + formatMoney(threshold, format).replace(/\.00$/, '');
      } else if (remaining > 0) {
        text.innerHTML =
          'YOU’RE <span class="sf-announce-amount">' + formatMoney(remaining, format) + '</span> AWAY FROM FREE SHIPPING ' +
          '<span class="sf-announce-bar" aria-hidden="true"><span style="width:' + pct + '%"></span></span>';
      } else {
        text.innerHTML =
          '🎉 YOU’VE GOT FREE SHIPPING! ' +
          '<a class="sf-announce-checkout" href="' + (el.dataset.checkoutUrl || '/checkout') + '">CHECKOUT</a>';
      }
    });
  }

  function renderPills(total) {
    pills.forEach(function (el) {
      var text = el.querySelector('[data-sf-ship-pill-text]');
      if (!text) return;
      var threshold = thresholdFor(el);
      var remaining = Math.max(threshold - total, 0);
      el.classList.toggle('is-unlocked', total > 0 && remaining === 0);
      if (total <= 0) {
        text.innerHTML = 'Free shipping over ' + formatMoney(threshold, el.dataset.moneyFormat).replace(/\.00$/, '');
      } else if (remaining > 0) {
        text.innerHTML = '<b>' + formatMoney(remaining, el.dataset.moneyFormat) + '</b> away from free shipping';
      } else {
        text.innerHTML = 'You’ve got FREE shipping!';
      }
    });
  }

  function refresh() {
    var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(rootUrl + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        render(cart.total_price || 0);
        renderPills(cart.total_price || 0);
      })
      .catch(function () {});
  }

  refresh();

  /* Re-check whenever the cart count changes (drawer, quick add, product form) */
  var bubble = document.getElementById('cart-icon-bubble');
  if (bubble) {
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      setTimeout(function () { queued = false; refresh(); }, 250);
    }).observe(bubble, { childList: true, subtree: true, characterData: true });
  }
  document.addEventListener('cart:updated', refresh);
  document.addEventListener('sf:cart-changed', refresh);
  window.sfRefreshFreeShipping = refresh;
})();
